import { IRequest } from '@r1-frontend/shared/types/IRequest';

export interface ICreateUnauthDealerRequest {
    dealerName: string,
    dealerPhone: string,
    dealerMail: string,
    dealerId: string,
    dlrCityId: string,
    clientName: string,
    clientPhone: string,
    clientCityId: string,
    comment?: string,
    interface?: string,
    source?: string,
    clientId?: string,
    appDealMethod?: string,
    posessPrice?: string,
    leasingPrice?: string,
    smartTv?: string,
    streetId?: string,
    houseNum?: string,
    houseBuild?: string,
    office?: string,
}

/*
 * Отправка заявки от неавторизованного дилера
 * https://master.api-request.sandbox.d2c.r-one.io/docs/v1#/%D0%94%D0%B8%D0%BB%D0%B5%D1%80%D1%8B/7656ac1882dd7f8ef3ee15acf73e7b17
 */
export const createUnauthRequest = (providerId: number, body: ICreateUnauthDealerRequest): IRequest => ({
    uri: '/v1/dealers/create-unauth-req',
    method: 'POST',
    headers: { providerId: `${providerId}` },
    body: JSON.stringify(body),
});
